"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeScreen = exports.IncomeAggregationPolicyName = exports.RelativeTimePeriod = exports.IncomeVerificationVersion = void 0;
/* @TranslateToPython */
var IncomeVerificationVersion;
(function (IncomeVerificationVersion) {
    IncomeVerificationVersion["INCOME_V1"] = "INCOME_V1";
    IncomeVerificationVersion["INCOME_V2"] = "INCOME_V2";
})(IncomeVerificationVersion || (exports.IncomeVerificationVersion = IncomeVerificationVersion = {}));
/* @TranslateToPython */
var RelativeTimePeriod;
(function (RelativeTimePeriod) {
    RelativeTimePeriod["YTD"] = "YTD";
    RelativeTimePeriod["Y_MINUS_ONE"] = "Y_MINUS_ONE";
    RelativeTimePeriod["Y_MINUS_TWO"] = "Y_MINUS_TWO";
})(RelativeTimePeriod || (exports.RelativeTimePeriod = RelativeTimePeriod = {}));
/* @TranslateToPython */
var IncomeAggregationPolicyName;
(function (IncomeAggregationPolicyName) {
    IncomeAggregationPolicyName["FIRST_LIEN_INCOME_AGGREGATION_POLICY"] = "FIRST_LIEN_INCOME_AGGREGATION_POLICY";
    IncomeAggregationPolicyName["SINGLE_SOURCE_INCOME_AGGREGATION_POLICY"] = "SINGLE_SOURCE_INCOME_AGGREGATION_POLICY";
    IncomeAggregationPolicyName["PLAID_AGGREGATION_POLICY"] = "PLAID_AGGREGATION_POLICY";
    IncomeAggregationPolicyName["IRS_DIRECT_AGGREGATION_POLICY"] = "IRS_DIRECT_AGGREGATION_POLICY";
    IncomeAggregationPolicyName["WORK_NUMBER_AGGREGATION_POLICY"] = "WORK_NUMBER_AGGREGATION_POLICY";
    IncomeAggregationPolicyName["MANUAL_DOCUMENT_AGGREGATION_POLICY"] = "MANUAL_DOCUMENT_AGGREGATION_POLICY";
    IncomeAggregationPolicyName["BANK_STATEMENT_AGGREGATION_POLICY"] = "BANK_STATEMENT_AGGREGATION_POLICY";
})(IncomeAggregationPolicyName || (exports.IncomeAggregationPolicyName = IncomeAggregationPolicyName = {}));
var IncomeScreen;
(function (IncomeScreen) {
    IncomeScreen["INCOME_VERIFICATIONS_IN_PROGRESS"] = "INCOME_VERIFICATIONS_IN_PROGRESS";
    IncomeScreen["INCOME_VERIFIED_PROCEED"] = "INCOME_VERIFIED_PROCEED";
    IncomeScreen["ERROR_HUMAN_INVESTIGATE"] = "ERROR_HUMAN_INVESTIGATE";
    IncomeScreen["MULTI_YEAR_FIRST_PASS"] = "MULTI_YEAR_FIRST_PASS";
    IncomeScreen["MULTI_YEAR_PARTIALLY_VERIFIED"] = "MULTI_YEAR_PARTIALLY_VERIFIED";
})(IncomeScreen || (exports.IncomeScreen = IncomeScreen = {}));
